import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '../../components/templates/Layout'

import CustomTable from '../../components/molecules/CustomTable'
import CustomSearch from '../../components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '../../common/components'
import { useFormik } from 'formik'
import CustomDialog from '../../components/organisms/Dialog'

import FieldManage from './fields'
import * as Yup from 'yup'
import FullScreenPopup from '../../components/organisms/FullScreenPopup'
import SecondaryButton from '../../components/atoms/SecondaryButton'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import SettingContext from '../../context/setting/settingContext'

const DynamicTablePages = (props) => {
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }
    const [isLoading, setIsLoading] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [allData, setAllData] = useState({})
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'dynamic_pages',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                          ? 1
                          : 0
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })
    const validationArray = Yup.object({
        description: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            description: '',
            table: 'dynamic_pages',
            active: 1,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            searchTableAction(values)
        },
    })

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            primaryTable: 'dynamic_pages',
            filters: {
                active: {
                    value: '2',
                    type: 'notin',
                    field: 'dp.active',
                },
                description: {
                    value: '',
                    type: 'like',
                    field: 'dp.description',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'dynamic_pages')
        },
    })

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formikFetch.values.filters.active.value = '2'
        formikFetch.values.page = 1
        formikFetch.values.filters.description.value = ''
        searchTableFetch(formikFetch.values, 'dynamic_pages')
    }, [])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'dynamic_pages') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setAllData(search_fetch_data)
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'CommunicationSearchTable') {
                    updateConfigColumn(null, true)
                    setChangeStatus(false)
                    toggleFullScreenPopup(false)
                    searchTableFetch(formikFetch.values, 'dynamic_pages')
                }
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            toggleFullScreenPopup(true, 'edit', id)
        } else if (type === 'view') {
            toggleFullScreenPopup(true, 'view', id)
        }
    }

    useEffect(() => {
        if (manage.status === 'edit') {
            formik.setFieldValue('id', manage.id)
            const template = tableBody.filter((cat) => cat.id === manage.id)
            formik.setFieldValue('description', template[0].description)
            formik.setFieldValue('active', template[0].active)
        } else if (manage.status === 'view') {
        } else {
            resetFrom()
        }
    }, [manage])

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('description', '')
        formik.setFieldValue('table', 'dynamic_pages')
        formik.handleReset()
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'description',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Page name',
        },
        // {
        //     field: 'active',
        //     condition: true,
        //     conditionValue: {
        //         formula: {
        //             key1: 'active',
        //             key2: 1,
        //             notation: '===',
        //         },
        //         true: {
        //             type: 'text',
        //             value: 'Active',
        //         },
        //         false: {
        //             type: 'text',
        //             value: 'Deactive',
        //         },
        //     },
        //     type: 'text',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Status',
        // },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            // secondaryClickID: 'proposed_amount',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: [
                // {
                //     buttonType: 'edit',
                //     clickType: 'edit',
                //     onclick: onClickEdit,
                //     tooltipTitle: 'Edit',
                // },
                {
                    buttonType: 'visibility',
                    clickType: 'view',
                    onclick: onClickEdit,
                    tooltipTitle: 'View Properties',
                },
            ],
        },
    ]
    const details = {
        formik: formik,
        data: [
            {
                label: 'Page name *',
                placeholder: 'Enter the page name',
                type: 'textarea',
                class: 'col-12',
                name: 'description',
            },
            {
                label: 'Active',
                placeholder: 'Make Active',
                type: 'switch',
                class: 'col-6',
                name: 'active',
            },
        ],
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const tableActions = []
    // tableActions.push(
    //     {
    //         label: 'Move to Active',
    //         icon: <span className="material-icons">check_circle</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'active',
    //     },
    //     {
    //         label: 'Move to Deactive',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'deactive',
    //     },
    //     {
    //         label: 'Delete Permanently',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'delete',
    //     },
    // )

    const searchInfo = {
        formik: formikFetch,
        data: [
            {
                label: 'Page name',
                placeholder: 'Enter page name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'description',
                filter: true,
            },
        ],
    }

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikFetch} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    {/* <Button
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New Page
                    </Button> */}
                </div>

                <CustomTable
                    formik={formikFetch.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={allData}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTableFetch}
                    changeTableFromVariable="dynamic_pages"
                    columnStorageVariable={'table_dynamic_table_pages'}
                />
            </div>
            <FullScreenPopup
                modaltitle={
                    manage.status === 'new' ? 'Add New Page' : 'Edit Page'
                }
                open={manage.popup}
                handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
            >
                <div className="dashboard addNewListing mt-4">
                    <div className="fspBody">
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {Object.values(mapData(details))}
                            </div>
                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <SecondaryButton
                                    id="dynamicPage_reset"
                                    label="Reset"
                                    type="reset"
                                    onClick={() => resetFrom()}
                                />
                                <PrimaryButton
                                    id="dynamicPage_submit"
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'delete'
                        ? 'Are you sure you want to delete'
                        : 'Are you sure you want to change the status'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="dynamicPage_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="dynamicPage_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <FieldManage data={manage} function={toggleFullScreenPopup} />
        </Layout>
    )
}
export default DynamicTablePages
